// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-form-main-back .paylixecommerce-note {
  font-weight: 400;
}

.payment-link-setup-title {
  margin-bottom: 1rem;
}

.payment-link-type-select-dropdown {
  min-width: 500px;
}
@media (max-width: 768px) {
  .payment-link-type-select-dropdown {
    min-width: unset;
  }
}
.payment-link-type-select-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent !important;
  width: 100%;
  padding: 0.5rem 0.5rem;
  cursor: pointer;
  border-radius: 0.5rem;
  margin: 0.5rem 0;
}
.payment-link-type-select-option-content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}
.payment-link-type-select-option-content span {
  background-color: transparent !important;
}
.payment-link-type-select-option-content span:first-child {
  color: var(--black9);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}
.payment-link-type-select-option-content span:last-child {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  color: var(--black5);
}
.payment-link-type-select-option:hover {
  background-color: var(--black1) !important;
}
.payment-link-type-select-option-container {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  color: var(--black9);
  font-size: 0.9rem;
}
.payment-link-type-select-option-icon {
  border-radius: 100%;
  background-color: var(--purple0);
  min-width: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.payment-link-type-select-option-icon.active {
  background-color: var(--purple0);
}
.payment-link-type-select-option-icon svg.active * {
  stroke: var(--purple6);
}
.payment-link-type-select-value {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent !important;
  width: 100%;
  padding: 0.25rem 1rem;
  cursor: pointer;
  position: absolute;
  pointer-events: none;
  white-space: nowrap;
}
.payment-link-type-select-value div {
  background-color: transparent !important;
}
.payment-link-type-select-value > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--black9) !important;
  font-size: 0.9rem;
  font-weight: 500;
}
.payment-link-type-select > div {
  width: 100%;
}

.new-type-widget {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--black2);
}
.new-type-widget.error > div {
  border: 2px solid var(--red6);
}
.new-type-widget-icon {
  border-radius: 100%;
  background: var(--black0);
  min-width: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.new-type-widget-icon.active {
  background: var(--purple0);
}
.new-type-widget-icon svg.active * {
  stroke: var(--purple6);
}
.new-type-widget-info {
  font-weight: 500;
  font-size: 14px;
}
.new-type-widget-info div {
  margin-bottom: 0.25rem;
}
.new-type-widget-info span {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--black5);
}
.new-type-widget > div {
  cursor: pointer;
  padding: 1.25rem;
  border-radius: 0.5rem;
  background: var(--white);
  border: 1px solid var(--black2);
  color: var(--black9);
  display: flex;
  gap: 0.75rem;
  width: calc(50% - 0.5rem);
  justify-content: space-between;
}
.new-type-widget > div.active {
  border: 2px solid var(--purple6);
}

.license-input-details {
  border-left: 1px solid var(--red6);
  font-size: 14px;
  font-weight: 400;
  right: 0;
  top: 29px;
  position: absolute;
  height: 40px;
  align-items: center;
  display: flex;
  padding: 1rem;
  color: var(--black9);
  width: 70px;
}

.settings-how {
  color: var(--black5);
  display: flex;
  padding-top: 1rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
}
.settings-how-block {
  padding: 1.25rem;
  background: var(--white);
  border-radius: 0.5rem;
  position: relative;
  width: 100%;
  border: 1px solid var(--black2);
}
.settings-how-block-title {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .settings-how {
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0;
  }
}
.settings-how.three > div {
  width: 33%;
}
.settings-how > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1rem 1rem;
  padding-bottom: 0;
  position: relative;
  width: 20%;
}
@media (max-width: 768px) {
  .settings-how > div:first-child {
    padding-top: 2rem;
  }
}
@media (max-width: 768px) {
  .settings-how > div {
    width: 100% !important;
    padding: 0.5rem 0;
    flex-direction: row;
    text-align: left;
  }
  .settings-how > div > div {
    margin-right: 1rem;
    margin-bottom: 0 !important;
  }
}
@media (max-width: 420px) {
  .settings-how > div {
    width: 100% !important;
    padding: 0;
    padding-bottom: 1.25rem;
  }
}
.settings-how > div:last-of-type > div:after {
  display: none;
}
.settings-how > div > div {
  min-width: 3rem;
  min-height: 3rem;
  width: 3rem;
  height: 3rem;
  border-radius: 100%;
  background: var(--purple0);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .settings-how > div > div {
    min-width: 2.5rem;
    min-height: 2.5rem;
    width: 2.5rem;
    height: 2.5rem;
  }
}
.settings-how > div > div:after {
  content: "";
  position: absolute;
  top: 2.5rem;
  width: calc(100% - 2rem - 2rem - 2rem);
  height: 2px;
  background: var(--black2);
  left: calc(50% + 3rem);
}
@media (max-width: 768px) {
  .settings-how > div > div:after {
    display: none;
  }
}

/* Works for Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Works for Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.discount-currency {
  position: absolute;
  height: 40px;
  bottom: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-weight: 500;
  font-size: 0.9rem;
  color: var(--black9);
}
.discount-currency + div input {
  padding-left: 2.25rem;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/product/index.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;;AAIA;EACE,mBAAA;AADF;;AAME;EACE,gBAAA;AAHJ;AAKI;EAHF;IAII,gBAAA;EAFJ;AACF;AAKE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,wCAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAHJ;AAKI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAHN;AAKM;EACE,wCAAA;AAHR;AAMM;EACE,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAJR;AAOM;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AALR;AASI;EACE,0CAAA;AAPN;AAUI;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AARN;AAWI;EACE,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATN;AAWM;EACE,gCAAA;AATR;AAYM;EACE,sBAAA;AAVR;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,wCAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AAbJ;AAeI;EACE,wCAAA;AAbN;AAgBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;AAdN;AAmBE;EACE,WAAA;AAjBJ;;AAwBA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,sCAAA;AArBF;AAwBI;EACE,6BAAA;AAtBN;AA0BE;EACE,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxBJ;AA0BI;EACE,0BAAA;AAxBN;AA2BI;EACE,sBAAA;AAzBN;AA8BE;EACE,gBAAA;EACA,eAAA;AA5BJ;AA8BI;EACE,sBAAA;AA5BN;AA8BI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AA5BN;AAgCE;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,+BAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;AA9BJ;AAgCI;EACE,gCAAA;AA9BN;;AAoCE;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,WAAA;AAjCJ;;AAqCA;EACE,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAlCF;AAoCE;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EAEA,+BAAA;AAnCJ;AAqCI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAnCN;AAwCE;EAjCF;IAkCI,eAAA;IACA,uBAAA;IACA,cAAA;EArCF;AACF;AAwCI;EACE,UAAA;AAtCN;AA0CE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAxCJ;AA2CM;EADF;IAEI,iBAAA;EAxCN;AACF;AA2CI;EAhBF;IAiBI,sBAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;EAxCJ;EA0CI;IACE,kBAAA;IACA,2BAAA;EAxCN;AACF;AA2CI;EA5BF;IA6BI,sBAAA;IACA,UAAA;IACA,uBAAA;EAxCJ;AACF;AA2CM;EACE,aAAA;AAzCR;AA6CI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA3CN;AA6CM;EAZF;IAaI,iBAAA;IACA,kBAAA;IACA,aAAA;IACA,cAAA;EA1CN;AACF;AA4CM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;AA1CR;AA4CQ;EATF;IAUI,aAAA;EAzCR;AACF;;AAiDA,0CAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AA9CF;;AAiDA,sBAAA;AACA;EACE,0BAAA;AA9CF;;AAiDA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AA9CF;AAgDE;EACE,qBAAA;AA9CJ","sourcesContent":[".product-form-main-back {\n  .paylixecommerce-note {\n    font-weight: 400;\n  }\n}\n\n.payment-link-setup-title {\n  margin-bottom: 1rem;\n}\n\n.payment-link-type-select {\n\n  &-dropdown {\n    min-width: 500px;\n\n    @media (max-width: 768px) {\n      min-width: unset;\n    }\n  }\n\n  &-option {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: transparent !important;\n    width: 100%;\n    padding: .5rem .5rem;\n    cursor: pointer;\n    border-radius: 0.5rem;\n    margin: 0.5rem 0;\n\n    &-content {\n      display: flex;\n      flex-direction: column;\n      gap: .125rem;\n\n      span {\n        background-color: transparent !important;\n      }\n\n      span:first-child {\n        color: var(--black9);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n      }\n\n      span:last-child {\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 400;\n        color: var(--black5);\n      }\n    }\n\n    &:hover {\n      background-color: var(--black1) !important;\n    }\n\n    &-container {\n      display: flex;\n      gap: 1rem;\n      justify-content: space-between;\n      align-items: center;\n      color: var(--black9);\n      font-size: .9rem;\n    }\n\n    &-icon {\n      border-radius: 100%;\n      background-color: var(--purple0);\n      min-width: 2.5rem;\n      width: 2.5rem;\n      height: 2.5rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &.active {\n        background-color: var(--purple0);\n      }\n\n      svg.active * {\n        stroke: var(--purple6);\n      }\n    }\n  }\n\n  &-value {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: transparent !important;\n    width: 100%;\n    padding: 0.25rem 1rem;\n    cursor: pointer;\n    position: absolute;\n    pointer-events: none;\n    white-space: nowrap;\n\n    div {\n      background-color: transparent !important;\n    }\n\n    & > div {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      color: var(--black9) !important;\n      font-size: .9rem;\n      font-weight: 500;\n    }\n  }\n\n\n  & > div {\n    width: 100%;\n  }\n\n\n}\n\n\n.new-type-widget {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid var(--black2);\n\n  &.error {\n    & > div {\n      border: 2px solid var(--red6);\n    }\n  }\n\n  &-icon {\n    border-radius: 100%;\n    background: var(--black0);\n    min-width: 2.5rem;\n    width: 2.5rem;\n    height: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &.active {\n      background: var(--purple0);\n    }\n\n    svg.active * {\n      stroke: var(--purple6);\n    }\n\n  }\n\n  &-info {\n    font-weight: 500;\n    font-size: 14px;\n\n    div {\n      margin-bottom: .25rem;\n    }\n    span {\n      font-size: 12px;\n      font-weight: 400;\n      line-height: 18px;\n      color: var(--black5);\n    }\n  }\n\n  & > div {\n    cursor: pointer;\n    padding: 1.25rem;\n    border-radius: 0.5rem;\n    background: var(--white);\n    border: 1px solid var(--black2);\n    color: var(--black9);\n    display: flex;\n    gap: .75rem;\n    width: calc(50% - .5rem);\n    justify-content: space-between;\n\n    &.active {\n      border: 2px solid var(--purple6);\n    }\n  }\n}\n\n.license-input {\n  &-details {\n    border-left: 1px solid var(--red6);\n    font-size: 14px;\n    font-weight: 400;\n    right: 0;\n    top: 29px;\n    position: absolute;\n    height: 40px;\n    align-items: center;\n    display: flex;\n    padding: 1rem;\n    color: var(--black9);\n    width: 70px;\n  }\n}\n\n.settings-how {\n  color: var(--black5);\n  display: flex;\n  padding-top: 1rem;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n\n  &-block {\n    padding: 1.25rem;\n    background: var(--white);\n    border-radius: 0.5rem;\n    position: relative;\n    width: 100%;\n    //box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n    border: 1px solid var(--black2);\n\n    &-title {\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 0;\n    }\n  }\n\n\n  @media (max-width: 768px) {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-top: 0;\n  }\n\n  &.three {\n    & > div {\n      width: 33%;\n    }\n  }\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 1rem 1rem;\n    padding-bottom: 0;\n    position: relative;\n    width: 20%;\n\n    &:first-child {\n      @media (max-width: 768px) {\n        padding-top: 2rem;\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: 100% !important;\n      padding: .5rem 0;\n      flex-direction: row;\n      text-align: left;\n\n      & > div {\n        margin-right: 1rem;\n        margin-bottom: 0 !important;\n      }\n    }\n\n    @media (max-width: 420px) {\n      width: 100% !important;\n      padding: 0;\n      padding-bottom: 1.25rem;\n    }\n\n    &:last-of-type > div {\n      &:after {\n        display: none;\n      }\n    }\n\n    & > div {\n      min-width: 3rem;\n      min-height: 3rem;\n      width: 3rem;\n      height: 3rem;\n      border-radius: 100%;\n      background: var(--purple0);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 1rem;\n\n      @media (max-width: 768px) {\n        min-width: 2.5rem;\n        min-height: 2.5rem;\n        width: 2.5rem;\n        height: 2.5rem;\n      }\n\n      &:after {\n        content: \"\";\n        position: absolute;\n        top: 2.5rem;\n        width: calc(100% - 2rem - 2rem - 2rem);\n        height: 2px;\n        background: var(--black2);\n        left: calc(50% + 3rem);\n\n        @media (max-width: 768px) {\n          display: none;\n        }\n      }\n\n    }\n  }\n\n}\n\n/* Works for Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Works for Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.discount-currency {\n  position: absolute;\n  height: 40px;\n  bottom: 0;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 1rem;\n  font-weight: 500;\n  font-size: .9rem;\n  color: var(--black9);\n\n  & + div input {\n    padding-left: 2.25rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
